import React from 'react'
import { putAwayConst } from '../../const/putAwayConst'
import { SwitchButton } from '../../../UI/SwitchButton/SwitchButton'
import { putAwayActions } from '../../actions/putAwayActions'
import { usePutAway } from '../../Context/usePutAway'

export const SwitchPutAway = () => {
  const { state, dispatch } = usePutAway()
  const { setSearch } = putAwayActions()
  const { options } = putAwayConst()

  const handleClick = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    field: string
  ) => {
    e.preventDefault()
    dispatch(setSearch(field))
  }

  return (
    <SwitchButton
      options={options}
      isSelected={state.isSelected}
      handleClick={handleClick}
    />
  )
}
